import { render, staticRenderFns } from "./AnzcorSearchApp.vue?vue&type=template&id=72b43770&"
import script from "./AnzcorSearchApp.vue?vue&type=script&lang=js&"
export * from "./AnzcorSearchApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports